import script from "./ChallengeHighscore.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChallengeHighscore.vue?vue&type=script&setup=true&lang=ts"

import "./ChallengeHighscore.vue?vue&type=style&index=0&id=1a5938d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a5938d0"]])

export default __exports__